import { gql } from "@apollo/client";

export const employeeOperation = {
    employeeAccount: "employeeAccountHrm",
    employeeHrm: "employeeHrm",
};

export const GET_EMPLOYEE_ACCOUNT = gql`
query getEmployeeAccountHrm(
    $date: Date
    $filter: String
    $page: Int
    $pageSize: Int
    $search: String
    $sort: String) {
    ${employeeOperation.employeeAccount}(
    date: $date
    filter: $filter
    page: $page
    pageSize: $pageSize
    search: $search
    sort: $sort) {
    
    items {
            name
            screenName
            departmentNameEmployee
            departmentName
            jobPositionName
            jobTitleName
            code
            externalReferenceCode
            id
    }
    page
    pageSize
    totalCount
    }
}

`;

export const GET_EMPLOYEE_HRM = gql`
query getEmployeeHrm(
    $date: Date
    $filter: String
    $page: Int
    $pageSize: Int
    $search: String
    $sort: String) {
    ${employeeOperation.employeeHrm}(
    date: $date
    filter: $filter
    page: $page
    pageSize: $pageSize
    search: $search
    sort: $sort) {
    
    items {
            name
            screenName
            departmentNameEmployee
            departmentName
            jobPositionName
            jobTitleName
            code
            externalReferenceCode
            id
    }
    page
    pageSize
    totalCount
    }
}

`;
